import { VariableCircuitoIn } from "../../services/usuarios.service";

export class Role {
    static readonly statusEnable = 'A';
    static readonly statusDisable = 'B';
    roleCode: string;
    description: string;
    systemCode: string;
    businessCode: string;
    status: string;
    profileCategoryIds: string[];
};

export class UserRoles {
    roles: Role[] = [];
    adminUserName: string;
    activeRoles: { [roleCode: string]: boolean} = {};
}


// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/model/classes/role.class.ts